import {isObject} from "../../Common/Enum/helper";
export default class LoggingHelper {
    static logToServer = (title, data) => {
        return $.ajax({
            url: '/merchant/api/logging',
            type: 'post',
            data: {
                title: title || '',
                to_log: isObject(data) ? JSON.stringify(data) : data,
            }
        })
    }
}